import { useQuery } from "@apollo/client";
import { Contract } from "@ethersproject/contracts";
import {
  AuroraTestnet,
  CronosTestnet,
  Goerli,
  Mumbai,
  OasisEmeraldTestnet,
  shortenAddress,
  useContractFunction,
  useEthers,
  useLookupAddress,
} from "@usedapp/core";
import React, { useEffect, useState } from "react";
import headerLogo from "./assets/logo.png";
import {
  Body,
  Button,
  ButtonDiv,
  ButtonSpan,
  Container,
  CreateButton,
  EpochButton,
  EthImage,
  Header,
  ListTitle,
  Logo,
  LogoDiv,
  MainModal,
  ModalSubTitle,
  ModalTitle,
  NavDiv,
  NavMainDiv,
  NavSpan,
  SideDiv,
  NewImage,
} from "./components";
import eth from "./assets/eth.svg";
import cronos from "./assets/cronos.svg";
import aurora from "./assets/aurora.svg";
import scale from "./assets/skale.svg";
import oasis from "./assets/oasis.svg";
import optimisim from "./assets/optimisim.svg";
import { abis, addresses } from "@my-app/contracts";
import { Col, Row } from "antd";
import CreateJob from "./components/CreateJob";
import ListJobs from "./components/ListJobs";
import { GET_USER_EPOCH_WALLETS } from "./graphql/subgraph";
import { biconomyInstance, setBiconomy, switchNetwork } from "./web3";
import { CHAINS } from "./constants";

function WalletButton() {
  const [rendered, setRendered] = useState("");
  console.log("rendered: ", rendered);

  const ens = useLookupAddress();
  const {
    account,
    activateBrowserWallet,
    deactivate,
    error,
    activate,
    library,
  } = useEthers();
  console.log("error: ", error);
  console.log("deactivate: ", deactivate);
  console.log("activateBrowserWallet: ", activateBrowserWallet);
  console.log("account: ", account);

  useEffect(() => {
    if (ens) {
      setRendered(ens);
    } else if (account) {
      setRendered(shortenAddress(account));
    } else {
      setRendered("");
    }
  }, [account, ens, setRendered]);

  useEffect(() => {
    if (error) {
      console.error("Error while connecting wallet:", error.message);
    }
  }, [error]);

  return (
    <>
      <Button
        onClick={() => {
          if (!account) {
            activateBrowserWallet();
          } else {
            deactivate();
          }
        }}
      >
        {rendered === "" && "Connect Wallet"}
        {rendered !== "" && rendered}
      </Button>
    </>
  );
}

function App() {
  const [currentAction, setCurrentAction] = useState("list");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { library, account, chainId } = useEthers();
  const { loading, error, data: userEpochWalletData } = useQuery(
    GET_USER_EPOCH_WALLETS,
    {
      variables: { id: account?.toLowerCase() },
    }
  );
  console.log("error: ", error);
  console.log("loading: ", loading);
  console.log("data: ", userEpochWalletData);

  let contract = new Contract(
    addresses[chainId ? chainId: CHAINS.Mumbai.chainId].epochWalletRegistry,
    abis.epochWalletRegistry,
    library
  );
  const {
    state: stateCreateWallet,
    send: sendCreateWallet,
  } = useContractFunction(contract, "createWallet", {
    transactionName: "CreateWallet",
  });

  // const activeEpochWallet = useActiveEpochWallet(account, chainId);

  const showModal = () => {
    console.log("clicked");
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const createWallet = async () => {
    await sendCreateWallet();
  };

  useEffect(() => {
    setBiconomy();
  }, [account, chainId]);

  // Read more about useDapp on https://usedapp.io/
  return (
    <>
      <MainModal
        title={null}
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        bodyStyle={{
          backgroundColor: "#130e1b",
          color: "rgb(181 175 195)",
        }}
      >
        {
          <>
            <ModalTitle>My Wallet</ModalTitle>
            <p>
              Active Epoch Wallet:{" "}
              {userEpochWalletData?.userEntity
                ? shortenAddress(
                    userEpochWalletData.userEntity?.activeWallet.walletAddress
                  )
                : "No Epoch Wallet"}
            </p>
            <ModalSubTitle>All Epoch Wallets</ModalSubTitle>
            {userEpochWalletData?.userEntity &&
              userEpochWalletData.userEntity?.wallets.map((wallet) => (
                <>
                  <p>- {wallet.walletAddress}</p>
                </>
              ))}
          </>
        }
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button onClick={createWallet} style={{ margin: 0 }}>
            Create New Wallet
          </Button>
        </div>
      </MainModal>
      <Container>
        <Header>
          <LogoDiv>
            <Logo src={headerLogo} />
          </LogoDiv>
          <ButtonDiv>
            <EpochButton>
              <ButtonSpan onClick={showModal}>
                Epoch Wallet:{" "}
                {userEpochWalletData?.userEntity
                  ? shortenAddress(
                      userEpochWalletData.userEntity.activeWallet.walletAddress
                    )
                  : "No Epoch Wallet"}
              </ButtonSpan>
            </EpochButton>
            <WalletButton />
          </ButtonDiv>
        </Header>
        <Body>
          {/* <Image src={logo} alt="ethereum-logo" />
        <p>
          Edit <code>packages/react-app/src/App.js</code> and save to reload.
        </p>
        <Link href="https://reactjs.org">Learn React</Link>
        <Link href="https://usedapp.io/">Learn useDapp</Link>
        <Link href="https://thegraph.com/docs/quick-start">
          Learn The Graph
        </Link> */}

          <Row>
            {/* <Col span={12}> */}
            {/* <h1>Epoch Protocol</h1> */}
            {/* <h4>Run Job</h4> */}
            {/* <Button
              type="primary"
              onClick={() => {
                setCurrentAction("list");
              }}
            >
              Run Job
            </Button> */}
            {/* <h4>Create a Job</h4> */}
            {/* <Button
              type="primary"
              onClick={() => {
                setCurrentAction("create");
              }}
            >
              Create Job
            </Button>
          </Col> */}
            <Col span={2}>
              <SideDiv>
                <NewImage
                  style={{
                    width: "3.5rem",
                    marginLeft: "2.2rem",
                    marginBottom: "2rem",
                  }}
                  src={eth}
                  onClick={() => {
                    switchNetwork(Goerli.chainId);
                  }}
                />

                <EthImage
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                  stroke-linejoin="round"
                  stroke-miterlimit="2"
                  viewBox="0 0 560 400"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    switchNetwork(Mumbai.chainId);
                  }}
                >
                  <path
                    d="M9.35243 4.83479C9.75516 4.61106 10.2448 4.61106 10.6475 4.83479L16.6475 8.16812C17.0708 8.40326 17.3333 8.84946 17.3333 9.33366V11.5015L14.6666 13.0003V10.1182L9.99996 7.52559L5.33329 10.1182V15.2158L9.99996 17.8084L21.3524 11.5015C21.7552 11.2777 22.2448 11.2777 22.6475 11.5015L28.6475 14.8348C29.0708 15.0699 29.3333 15.5161 29.3333 16.0003V22.667C29.3333 23.1512 29.0708 23.5974 28.6475 23.8325L22.6475 27.1659C22.2448 27.3896 21.7552 27.3896 21.3524 27.1659L15.3524 23.8325C14.9292 23.5974 14.6666 23.1512 14.6666 22.667V20.4992L17.3333 19.0003V21.8825L22 24.4751L26.6666 21.8825V16.7849L22 14.1923L10.6475 20.4992C10.2448 20.7229 9.75516 20.7229 9.35243 20.4992L3.35243 17.1659C2.92916 16.9307 2.66663 16.4845 2.66663 16.0003V9.33366C2.66663 8.84946 2.92916 8.40326 3.35243 8.16812L9.35243 4.83479Z"
                    fill="rgb(181 175 195)"
                    fill-rule="nonzero"
                    transform="matrix(7.04961 0 0 7.04961 145 81.9191)"
                  />
                </EthImage>
                <NewImage
                  onClick={() => {
                    switchNetwork(CHAINS.Cronos.chainId);
                  }}
                  src={cronos}
                />
                <NewImage
                  onClick={() => {
                    switchNetwork(AuroraTestnet.chainId);
                  }}
                  src={aurora}
                />
                <NewImage
                  style={{ width: "4.5rem", marginLeft: "3.2rem" }}
                  src={scale}
                  onClick={() => {
                    switchNetwork(CHAINS.Skale.chainId);
                  }}
                />
                <NewImage
                  style={{ width: "4.5rem", marginLeft: "3.2rem" }}
                  src={optimisim}
                  onClick={() => {
                    switchNetwork(CHAINS.Optimism.chainId);
                  }}
                />
                <NewImage
                  src={oasis}
                  onClick={() => {
                    switchNetwork(OasisEmeraldTestnet.chainId);
                  }}
                />
                {/* <path
                    d="M162 83a15.92 15.92 0 0 1 14.31 8.84l45 90A16 16 0 0 1 207 205h-90a16 16 0 0 1-14.31-23.16l45-90A15.92 15.92 0 0 1 162 83m0-11a27 27 0 0 0-24.15 14.92l-45 90A27 27 0 0 0 117 216h90a27 27 0 0 0 24.15-39.08l-45-90A27 27 0 0 0 162 72z"
                    fill="rgb(181 175 195)"
                    fill-rule="nonzero"
                    transform="matrix(7.04961 0 0 7.04961 145 81.9191)"
                  /> */}
                {/* <EthImage
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                  stroke-linejoin="round"
                  stroke-miterlimit="2"
                  viewBox="0 0 560 400"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M162 83a15.92 15.92 0 0 1 14.31 8.84l45 90A16 16 0 0 1 207 205h-90a16 16 0 0 1-14.31-23.16l45-90A15.92 15.92 0 0 1 162 83m0-11a27 27 0 0 0-24.15 14.92l-45 90A27 27 0 0 0 117 216h90a27 27 0 0 0 24.15-39.08l-45-90A27 27 0 0 0 162 72z"
                    fill="rgb(181 175 195)"
                    fill-rule="nonzero"
                    transform="matrix(7.04961 0 0 7.04961 145 81.9191)"
                  />
                </EthImage> */}
                {/* <EthImage src={ethImg} />
              <EthImage src={ethImg} />
              <EthImage src={ethImg} />  */}
              </SideDiv>
            </Col>
            <Col span={3}>
              <NavMainDiv>
                <CreateButton
                  type="primary"
                  onClick={() => {
                    setCurrentAction("create");
                  }}
                >
                  Create Job
                </CreateButton>
                <NavDiv>
                  <NavSpan>My Tasks</NavSpan>
                  <NavSpan
                    onClick={() => {
                      setCurrentAction("list");
                    }}
                  >
                    All Tasks
                  </NavSpan>
                  <NavSpan onClick={showModal}>My Wallet</NavSpan>
                  <NavSpan>Tasks History</NavSpan>
                  <NavSpan>Help</NavSpan>
                  <NavSpan>Docs</NavSpan>
                  <NavSpan>Explore</NavSpan>
                </NavDiv>
              </NavMainDiv>
            </Col>
            <Col span={12}>
              {currentAction === "list" ? <ListJobs /> : null}
              {currentAction === "create" ? <CreateJob /> : null}
            </Col>
          </Row>
        </Body>
      </Container>
    </>
  );
}

export default App;
